import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MotifButton } from '@ey-xd/motif-react';
import {
  subHeaderPLPastMonthDetails,
  subHeaderPLPastQtrDetails,
} from '@services/pursuitLeaderServices';
import { structureMonth } from '@util/commonUtil';
import {
  QuarterTitle,
  SubHeaderContainer,
  SubmitButtonContainer,
} from '@atoms/subHeaderText/subHeader.styles';
import { BUTTON_TITLE } from '@constants/commonConstants';
import { useRecoilValue } from 'recoil';
import { Current_User } from '@recoil/recoil';

const SubHeaderPLPast = props => {
  const navigate = useNavigate();
  //Below Line direct-import-and-test-needed
  const [subHeaderData, setSubHeaderData] = useState([]); // eslint-disable-line
  const currentUser = useRecoilValue(Current_User);

  const MONTH = props.month;
  const YEAR = props.year;
  const forecast_type = props.forecast_type;
  const QUARTER = props.quarter;
  const fetchDateRange = async () => {
    const data = await (forecast_type === 'quarter'
      ? subHeaderPLPastQtrDetails(QUARTER, YEAR, currentUser.email)
      : forecast_type === 'month'
        ? subHeaderPLPastMonthDetails(QUARTER, MONTH, YEAR, currentUser.email)
        : Promise.reject(new Error('Invalid forecast_type')));

    setSubHeaderData(data);
  };

  useEffect(() => {
    fetchDateRange();
  }, [forecast_type, MONTH, YEAR, QUARTER]);

  const fullMonth = MONTH ? structureMonth(MONTH) : '';
  const quarter = QUARTER.charAt(1);

  const renderQuarterInfo = () => {
    if (setSubHeaderData.length !== 0) {
      return (
        <>
          {forecast_type === 'quarter' ? (
            <QuarterTitle>
              Quarter {quarter} FY {YEAR}
            </QuarterTitle>
          ) : (
            <QuarterTitle>
              {fullMonth} FY {YEAR}
            </QuarterTitle>
          )}
        </>
      );
    }
  };

  return (
    <SubHeaderContainer>
      {renderQuarterInfo()}
      <SubmitButtonContainer>
        <MotifButton
          variant="secondary"
          className="submitButton"
          onClick={() => {
            navigate('/');
          }}
        >
          {BUTTON_TITLE.CLOSE}
        </MotifButton>
      </SubmitButtonContainer>
    </SubHeaderContainer>
  );
};

export default SubHeaderPLPast;
